export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "reduceCanvasTo256Color.worker.d45d05eb0c437ee700a0.worker.js");
}
